module.exports = __webpack_public_path__ + "img/section-2--bg.184116f5.jpg";